import React from 'react';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import HighlightsSection from './components/HighlightsSection';
import CallToAction from './components/CallToAction';

const Home = () => {
  return (
    <div className="overflow-hidden">
      <HeroSection />
      <AboutSection />
      <HighlightsSection />
      <CallToAction />
    </div>
  );
};

export default Home;